import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
const helpMessages: Record<
  string,
  {
    message: string;
    position: "top" | "bottom" | "left" | "right";
    textAlign?: "top" | "middle" | "bottom" | "start" | "center" | "end";
    //  verticalAlign?: "start" | "middle" | "end";
    lineType?: "line" | "arrow" | "both";
  }
> = {
  newProject: {
    message: "Click the button to create a new project.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  renewNow: {
    message: "Click the button to renew your current plan.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  recentProjects: {
    message: "List of Recent Created Project.",
    position: "right",
    textAlign: "middle",
    lineType: "both",
  },
  newProjectPage: {
    message: "Click here to create a new project.",
    position: "top",
    textAlign: "center",
    lineType: "both",
  },
  downloadProject: {
    message: 'Hover and then click on "Download" to download sample projects.',
    position: "bottom",
    textAlign: "center",
    lineType: "line",
  },
  favourProject: {
    message: "Click on the heart icon to add your project to the favourites page.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  favourPage: {
    message: "Click on the heart icon to remove your project from the favourites page.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  filterUploadImages: {
    message: "Select a filter to view all, annotated, or unannotated images.",
    position: "bottom",
    textAlign: "center",
    lineType: "both",
  },
  addMoreFiles: {
    message: "Click here to upload more images/video.  ",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  uploadPagination: {
    message: "Click here to view the previous or next set of images. ",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  imageDetails: {
    message: "Click the image to view its details. Click the annotate button to go to the annotation page.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  addSelectLabel: {
    message: "Click to show the list of labels and add a new label.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
 selectLabel: {
    message: "Click to show the list of labels and add a new label.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
 backButton: {
    message: "Click the back button to go previous selection.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
 addMoreBlock: {
    message: "Use add button to add another upload section.",
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  annotationFilter: {
    message: "Select the radio button to display only annotated/unannotated images.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  imageBox: {
    message: "Click on the image icon to browse all uploaded images.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  selectImage: {
    message:
      "Use the left and right arrows to switch between images.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  select: {
    message: "Click on the select icon to modify existing annotations.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  addRectangle: {
    message:
      "Use the rectangle tool to draw a bounding box on the image for annotation.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  addPolygon: {
    message:
      "Use the polygon tool to draw a shape on the image for annotation.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  magicWand: {
    message:
      "Use the magic wand tool to perform auto-annotation by clicking on an object in the image.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  pan: {
    message:
      "Click on the hand icon to move the image and view hidden parts.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  anotatedLabel: {
    message:
      "Click on the double-left arrow icon to view all labels used in the current image.",
    position: "left",
    textAlign: "top",
    lineType: "arrow",
  },
  moreOptions: {
    message: "Click to view more option.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  anotatedLabelGroup: {
    message: "Use checkbox to select group of lable.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  createNewModel: {
    message: 'Click on "Create New Model +" to start building your AI model.',
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  listOfModels: {
    message: "List of trained models.",
    position: "right",
    textAlign: "middle",
    lineType: "line",
  },
  presentStatus: {
    message:
      "The graph shows the annotation counts for each label in your dataset.",
    position: "top",
    textAlign: "center",
    lineType: "line",
  },
  outlinedAdornmentWeight: {
    message: "Customize your model name.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  epochSize: {
    message: "Modify the epoch value to improve the model's quality.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  splitDataset: {
    message: "Adjust the split dataset to improve the model's performance.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  modelStartButton: {
    message: "Click here to create a new model and start training.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  modelType: {
    message: "Pick a model type.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  modelSize: {
    message: "Choose a model size based on your dataset.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  testUploadImage: {
    message:
      'click "Change Image" to select an image from your device.',
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  testUploadImageMain: {
    message:
      'Drag and drop your image here, or click "Browse" to select an image from your device.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  uploadImageUpload: {
    message:
      'Click "Browse" to select an images/video from your device.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  uploadImageOnly: {
    message:
      'Click "Browse" to select an images from your device.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  selectUploadSection: {
    message:
      'Select the section to upload the images.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  testChooseModel: {
    message: 'Choose your trained model from the "Select Model" dropdown menu.',
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  testButton: {
    message:
      'Click the "Perform Test" button to run the model and get the result of the uploaded image.',
    position: "bottom",
    textAlign: "start",
    lineType: "line",
  },
  testDownloadModel: {
    message:
      'Click "Download Model" to export and use your trained model in other applications.',
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  trainDownloadModel: {
    message:
      'Click the download button to export and use your trained model in other applications.',
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  testCompare: {
    message:
      'Check the "Compare" box to compare results across multiple models.',
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  modelViewDetail: {
    message:
      "Clicking on the model opens the detailed Model Performance section, displaying the Confusion Matrix, Total Images, and Annotations.",
    position: "bottom",
    textAlign: "center",
    lineType: "line",
  },
  trainModelViewDetail: {
    message:
      "Details of Model Performance result graphs.",
    position: "left",
    textAlign: "middle",
    lineType: "line",
  },
  modelMoreDetail: {
    message:
      "Click on the three-dot menu (⋮) on a model to rename, delete, or download it.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  modelDownload: {
    message: "Use checkboxes to select and download multiple models.",
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  modelDownloadButton: {
    message:
      "After selecting the checkboxes, click the download button to download the selected models.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  labelAugmentations: {
    message:
      "Use the augmentation option to properly train your model and achieve better results based on your requirements.",
    position: "top",
    textAlign: "center",
    lineType: "line",
  }, /////////
  searchTopBar: {
    message:
      "Search your projects and models.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  fullWidth: {
    message:
      "Enter your project name, it should not already exist.",
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  modelName: {
    message:
      "Enter your model name, it should not already exist.",
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  projectTypeId: {
    message:
      "Select your project task based on your requirements.",
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  projectDomain: {
    message:
      "Select your domain based on your requirements",
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  deleteImage: {
    message:
      "Click the button to delete the image.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  publishButton: {
    message:
      "Click the button to publish your model and list in models pages.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  downloadImage: {
    message:
      "Click the download icon to download the test result image.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  workFlowVidoe: {
    message:
      "Vision Studio App Workflow Video.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  closePopup: {
    message:
      "Click to close the popup.",
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  confirmDeletePopup: {
    message:
      'Click "OK" to delete the image.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  confirmDeleteButtonPopup: {
    message:
      'Click "Delete" to delete the image.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  calcelDeletePopup: {
    message:
      'Click "Cancel" to skip the image deletion.',
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  confirmDeleteProject: {
    message:
      'Click "Delete" to delete the project.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  calcelDeleteProject: {
    message:
      'Click "Cancel" to skip the project deletion.',
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  confirmDeleteLabel: {
    message:
      'Click "Delete" to delete the label.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  calcelDeleteLabel: {
    message:
      'Click "Cancel" to skip the label deletion.',
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  confirmDeleteModel: {
    message:
      'Click "Delete" to delete the model.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  calcelDeleteModel: {
    message:
      'Click "Cancel" to skip the model deletion.',
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  projectTypePopup: {
    message:
      "Project details.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  labelProjectPopup: {
    message:
      "List of labels used in the project.",
    position: "top",
    textAlign: "center",
    lineType: "line",
  },
  performanceChat: {
    message:
      "Graph of labels and annotation counts.",
    position: "bottom",
    textAlign: "center",
    lineType: "line",
  },
  projectName: {
    message:
      "Modify your project name, but it should not already exist.",
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  rangeAdjushment: {
    message:
      'Adjust the range to set frames per second, then click the "Capture Frames" button.',
    position: "top",
    textAlign: "center",
    lineType: "arrow",
  },
  selectImagesMultiple: {
    message:
      'Click on an image to select it for upload.',
    position: "bottom",
    textAlign: "center",
    lineType: "line",
  },
  selectAllImages: {
    message:
      'Use the checkbox to select all images for upload.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  uploadSelectedImages: {
    message:
      'Click the "Add to Dataset" button to upload the selected images.',
    position: "bottom",
    textAlign: "center",
    lineType: "arrow",
  },
  watchNowButton: {
    message:
      'Click the button to learn how to use our application.',
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
  annotatePin: {
    message:
      'Click the pin icon to lock the annotated labels section.',
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  stopAnnotate: {
    message:
      'Click the button to stop annotating.',
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  startAnnotate: {
    message:
      'Click the button before starting annotation.',
    position: "left",
    textAlign: "middle",
    lineType: "arrow",
  },
  labelListHelp: {
    message:
      'Select the checkbox to display the annotated labels list.',
    position: "right",
    textAlign: "middle",
    lineType: "arrow",
  },
};



const HelpPopup = ({
  isHelpOpen,
  onClose,
}: {
  isHelpOpen: boolean;
  onClose: () => void;
}) => {
  const [highlightBoxes, setHighlightBoxes] = useState<
    {
      id: string;
      text: string;
      position: "top" | "bottom" | "left" | "right";
      textAlign?: "top" | "middle" | "bottom" | "start" | "center" | "end";
      //  verticalAlign?: "start" | "middle" | "end";
      lineType?: "line" | "arrow" | "both";
      top: number;
      left: number;
      width: number;
      height: number;
    }[]
  >([]);

/* commanded by siva its working fine without any error but its showing the text of hidden part as well. Once testing is done working properly then remove this command code.
   useEffect(() => {
    if (!isOpen) return;

    const elements = Object.keys(helpMessages)
      .map((id) => {
        const element = document.getElementById(id);
        if (!element) return null;
        const rect = element.getBoundingClientRect();
        return {
          id,
          text: helpMessages[id].message,
          position: helpMessages[id].position,
          textAlign: helpMessages[id].textAlign,
          //  verticalAlign: helpMessages[id].verticalAlign,
          lineType: helpMessages[id].lineType,
          top: rect.top + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width,
          height: rect.height,
        };
      })
      .filter(Boolean) as any[];

    //console.log("id"+JSON.stringify(elements));
    setHighlightBoxes(elements);
  }, [isOpen]);
 */

  const { name, isOpen} = useSelector(
    (state: RootState) => state.UIReducer.modalOpen
  );


  useEffect(() => {
    if (!isHelpOpen) return;
    
    const elements = Object.keys(helpMessages)
    .map((id) => {
      if(isOpen){
        localStorage.setItem("popupOpen", true.toString());
        localStorage.setItem("secondPopupOpen", true.toString());
      }else{
      //  localStorage.setItem("secondPopupOpen", false.toString());
      }
      const popupOpen = localStorage.getItem("popupOpen");
      const secondPopupOpen = localStorage.getItem("secondPopupOpen");
      const showImageDrawer = localStorage.getItem("showImageDrawer");
      const popupOpenMenu = localStorage.getItem("popupOpenMenu");
      const showAnnotateLabelDrawer = localStorage.getItem("showAnnotateLabelDrawer");

      //console.log(secondPopupOpen+"secondPopupOpen");
        //console.log(name,isOpen);
        const element = document.getElementById(id);
        const skipIdSecond = ["deleteImage"];
        const skipIds = ["newProject", "recentProjects", "renewNow", "newProjectPage", "moreOptions", "favourProject", "filterUploadImages", "addMoreFiles", "imageDetails", "uploadPagination", "searchTopBar", "downloadProject","imageBox","addSelectLabel","annotationFilter","selectImage","anotatedLabel","select","addRectangle","addPolygon","magicWand","pan","createNewModel","presentStatus","listOfModels","trainModelViewDetail","publishButton","downloadImage","modelMoreDetail","modelViewDetail","watchNowButton"];
        const skipIdDropDown = ["outlinedAdornmentWeight","epochSize","modelType", "listOfModels", "labelAugmentations", "demo-radio-buttons-group-label"];
      //  console.log(name,popupOpen,id,skipIds.includes(id));
      if(showImageDrawer==="true" && id==="imageBox"){
        return null;
      }
      if(popupOpenMenu==="true" && skipIdDropDown.includes(id)){
        return null;
      }
      if(showAnnotateLabelDrawer==="true" && id==="anotatedLabel"){
        return null;
      }
      if (popupOpen==="true" && skipIds.includes(id)) {
        return null; // Exits the function
      }
      if(secondPopupOpen==="true" && skipIdSecond.includes(id)){
        return null;
      }
        if (!element) return null;
  
        const rect = element.getBoundingClientRect();
  
        // Find the closest scrollable parent
        const getScrollableParent = (node: HTMLElement | null): HTMLElement | null => {
          while (node) {
            const { overflow, overflowX, overflowY } = getComputedStyle(node);
            if (/(auto|scroll)/.test(overflow + overflowX + overflowY)) {
              return node;
            }
            node = node.parentElement;
          }
          return document.documentElement; // Default to the document
        };
  
        const scrollableParent = getScrollableParent(element);
        const parentRect = scrollableParent?.getBoundingClientRect();
  
        // Ensure the element is within both the viewport and the scrollable parent
        const isVisible =
          rect.top >= (parentRect?.top || 0) &&
          rect.left >= (parentRect?.left || 0) &&
        //  rect.bottom <= (parentRect?.bottom || window.innerHeight) &&
          rect.right <= (parentRect?.right || window.innerWidth);
        //console.log(rect,parentRect);
        if (!isVisible) return null; // Skip if the element is not visible in its scrollable parent
  
        return {
          id,
          text: helpMessages[id].message,
          position: helpMessages[id].position,
          textAlign: helpMessages[id].textAlign,
          lineType: helpMessages[id].lineType,
          top: rect.top + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width,
          height: rect.height,
        };
      })
      .filter(Boolean) as any[];
  
    setHighlightBoxes(elements);
  }, [isHelpOpen]);
  
  



  if (!isHelpOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.6)",
        zIndex: 999999,
      }}
      onClick={onClose}
    >
      {highlightBoxes.map((box) => {
        let lineElement = null;
        let middleArrow = null;
        let sideArrow1 = null;
        let sideArrow2 = null;
        let textStyle: React.CSSProperties = {}; // Declare first

        switch (box.position) {
          case "top":
          case "bottom":
            if (box.lineType === "arrow") {
              middleArrow = (
                /* <div
                  style={{
                    position: "absolute",
                    top:
                      box.position === "top"
                        ? box.top - 20
                        : box.top + box.height + 5,
                    left: box.left + box.width / 2 - 5,
                    color: "white",
                    fontSize: "20px",
                  }}
                >
                  {box.position === "bottom" ? "▲" : "▼"}
                </div> */

                <>
                  <div
                    style={{
                      position: "absolute",
                      top:
                        box.position === "top"
                          ? box.top - 20
                          : box.top + box.height + 5,
                      left: box.left + box.width / 2 - 5,
                      color: "white",
                      fontSize: "20px",
                    }}
                  >
                    {box.position === "bottom" ? "▲" : "▼"}
                  </div>

                  {/* Line element */}
                  <div
                    style={{
                      position: "absolute",
                      top:
                        box.position === "top"
                          ? box.top - 30
                          : box.top + box.height + 21, // Adjust line position
                      left:
                        box.left +
                        box.width / 2 +
                        (box.position === "top" ? 3 : 4), // Center align the line
                      width: "3px",
                      height: "20px", // Line height
                      backgroundColor: "white",
                    }}
                  ></div>
                </>
              );
            }

            if (box.lineType === "line" || box.lineType === "both") {
              lineElement = (
                <div
                  style={{
                    position: "absolute",
                    top:
                      box.position === "top"
                        ? box.top - 8
                        : box.top + box.height + 12,
                    left: box.left,
                    width: box.width,
                    height: "2px",
                    background: "white",
                  }}
                />
              );
              sideArrow1 = (
                <div
                  style={{
                    position: "absolute",
                    top:
                      box.position === "top"
                        ? box.top - 15
                        : box.top + box.height + 5,
                    left: box.left - 5,
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  ◄
                </div>
              );
              sideArrow2 = (
                <div
                  style={{
                    position: "absolute",
                    top:
                      box.position === "top"
                        ? box.top - 15
                        : box.top + box.height + 5,
                    left: box.left + box.width - 10,
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  ►
                </div>
              );
            }
            //console.log(box.text.length);
            textStyle = {
              position: "absolute",
              top:
                box.position === "top"
                  ? box.top - (box.lineType === "arrow" ? 49 : 35)
                  : box.top + box.height + (box.lineType === "arrow" ? 46 : 22),
              left:
                box.textAlign === "start"
                  ? box.left - box.text.length * 3.4
                  : box.textAlign === "center"
                  ? box.left + (box.width / 2 - box.text.length * 3.4)
                  : box.left + box.width - box.text.length * 3.4, // "end" case

              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
              whiteSpace: "nowrap",
              //maxWidth: "520px",
            };
            break;

          case "left":
          case "right":
            if (box.lineType === "arrow") {
              middleArrow = (
                /* <div
                  style={{
                    position: "absolute",
                    top: box.top + box.height / 2 - 10,
                    left:
                      box.position === "left"
                        ? box.left - 20
                        : box.left + box.width + 5,
                    color: "white",
                    fontSize: "20px",
                  }}
                >
                  {box.position === "right" ? "◄" : "►"}
                </div> */
                <>
                  {/* Arrow Indicator */}
                  <div
                    style={{
                      position: "absolute",
                      top: box.top + box.height / 2 - 10,
                      left:
                        box.position === "left"
                          ? box.left - 20
                          : box.left + box.width + 5,
                      color: "white",
                      fontSize: "20px",
                    }}
                  >
                    {box.position === "right" ? "◄" : "►"}
                  </div>

                  {/* Line Indicator */}
                  <div
                    style={{
                      position: "absolute",
                      top: box.top + box.height / 2, // Align with arrow
                      left:
                        box.position === "left"
                          ? box.left - 32
                          : box.left + box.width + 20, // Adjust for right side
                      width: "20px", // Line width
                      height: "3px", // Line height
                      backgroundColor: "white",
                    }}
                  ></div>
                </>
              );
            }

            if (box.lineType === "line" || box.lineType === "both") {
              lineElement = (
                <div
                  style={{
                    position: "absolute",
                    top: box.top + 7,
                    left:
                      box.position === "left"
                        ? box.left - 10
                        : box.left + box.width + 5,
                    width: "2px",
                    height: box.height - 5,
                    background: "white",
                  }}
                />
              );
              sideArrow1 = (
                <div
                  style={{
                    position: "absolute",
                    top: box.top,
                    left:
                      box.position === "left"
                        ? box.left - 16
                        : box.left + box.width - 1,
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  ▲
                </div>
              );
              sideArrow2 = (
                <div
                  style={{
                    position: "absolute",
                    top: box.top + box.height - 10,
                    left:
                      box.position === "left"
                        ? box.left - 16
                        : box.left + box.width - 1,
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  ▼
                </div>
              );
            }

          //  console.log(box.text);
            textStyle = {
              position: "absolute",
              top:
                box.textAlign === "top"
                  ? box.top + 2
                  : box.textAlign === "middle"
                  ? box.top + box.height / 2 - 8
                  : box.textAlign === "bottom"
                  ? box.top + box.height - 10
                  : box.top,

              left:
                box.position === "left"
                  ? box.left - 40
                  : box.left + box.width + (box.lineType === "arrow" ? 46 : 20),
              transform: box.position === "left" ? "translateX(-100%)":  "translateX(1%)",
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
              whiteSpace: "nowrap",
              //maxWidth: "520px",
            };

            break;
        }

        return (
          <div key={box.id}>
            <CloseOutlinedIcon
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              borderRadius: "50%",
              background: "none",
              color: "white",
              border: "1px solid white",
              height: "16px",
              width: "16px",
              textAlign: "center",
              padding: "3px",
              cursor: "pointer",
              zIndex: "999999",
            }}
          />
            {/* Page Heading */}
            {/* <h1
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "64px",
                fontWeight: "100",
                color: "white",
                textAlign: "center",
              }}
            >
              Project
            </h1> */}

            {/* Other elements */}
            {lineElement}
            {sideArrow1}
            {sideArrow2}
            {middleArrow}

            {/* Centered Box Text */}
            <div style={textStyle} dangerouslySetInnerHTML={{ __html: box.text }} />

          </div>
        );
      })}
    </div>
  );
};

export default HelpPopup;
